import { useTranslation } from '@thoughtspot/i18n';
import { TableListView } from '@thoughtspot/radiant-react/widgets/table/table-list-view';
import React, { useCallback } from 'react';
import { getColumnDefinitionsForMlIntegrations, TranslationsKeys, } from '../util';
import styles from './integration-list.module.scss';
export const IntegrationList = ({ integrationsList, integrationsListLoading, onEdit, onDelete, }) => {
    const columnDefinitions = getColumnDefinitionsForMlIntegrations();
    const { t } = useTranslation();
    const defaultOptions = {
        hasCheckboxes: false,
    };
    const getRowMenu = useCallback((row) => {
        const editMenuItem = {
            id: 'edit',
            label: t(TranslationsKeys.EDIT_ACTION),
            onClick: () => onEdit(row),
        };
        const deleteRuleMenuItem = {
            id: 'delete',
            label: t(TranslationsKeys.DELETE_ACTION),
            onClick: () => onDelete(row),
        };
        const items = [editMenuItem, deleteRuleMenuItem];
        return {
            title: '',
            items,
        };
    }, [onEdit, onDelete]);
    return (React.createElement(TableListView, { className: styles.tableList, "data-testid": "integration-list", data: integrationsList, options: defaultOptions, rowMenu: getRowMenu, columns: columnDefinitions, loading: integrationsListLoading }));
};
//# sourceMappingURL=integration-list.js.map